module.exports = __webpack_public_path__ + "images/wave/feedbacks/ean.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/wave/feedbacks/ean.png
// module id = /30I
// module chunks = 4